import React, { useEffect, useState } from 'react'
import { IModal } from './Assignments'
import { Toolbar } from 'primereact/toolbar'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'
import { Fetch, ILazyParams } from '../../shared/Fetch'
import { format } from 'date-fns';
import { emptyAssignment, IAssignment } from './Form'
import { ILogin, IPermissionProps } from '../../models/Login'
// import { ViewAssignment } from './ViewAssignment';
import { OverlayPanel } from 'primereact/overlaypanel';
import { useRef } from 'react';
import { InputText } from 'primereact/inputtext'
import { Dialog } from 'primereact/dialog'
import { InputTextarea } from 'primereact/inputtextarea'
import { Dropdown } from 'primereact/dropdown';
import { ProgressBar } from 'primereact/progressbar';
import { Accordion, AccordionTab } from "primereact/accordion";
import { EmptyAssignmentFilter, Filter, IAssignmentFilter } from './Filter'
import { Rating } from 'primereact/rating';
import { Card } from 'primereact/card'
import { safeFormatDate } from '../../models/DateFormatMapper'

interface Iprops {
    setModal: (modal: IModal) => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    permissions: IPermissionProps,
}

const verifyOptions = [
    { label: 'Verified', value: true },
    { label: 'Reject', value: false },
];

export const Table = (props: Iprops) => {
    const [tableData, setTableData] = useState<IAssignment[]>([]);
    // const [assignment, setAssignment] = useState<any[]>([]);
    const [dialogVisible, setDialogVisible] = useState<boolean>(false);
    const [selectedDate, setSelectedDate] = useState<string | null>(null);
    const [dialogInputValue, setDialogInputValue] = useState<number>();
    const [selectedRowData, setSelectedRowData] = useState<any | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [verifyDialogVisible, setVerifyDialogVisible] = useState(false);
    const [verifyStatus, setVerifyStatus] = useState<boolean | null>(null);
    const [rejectionReason, setRejectionReason] = useState<string>('');
    const [selectedRow, setSelectedRow] = useState<number | null>(null);
    const [selectedData, setSelectedData] = useState<IAssignment>();
    const [rejectedReason, setRejectedReason] = useState<IAssignment>();
    const overlayPanelRef = useRef<OverlayPanel>(null);
    const rejectOverlayPanelRef = useRef<OverlayPanel>(null);
    const [filters, setFilters] = useState<IAssignmentFilter>(EmptyAssignmentFilter);
    const [rating, setRating] = useState<any[]>([]);
    const [totalRecords, setTotalRecords] = useState();
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'login_ID',
        sortOrder: -1
    });

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    console.log(totalRecords);

    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    console.log(loginObj.id);
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const leftToolbarTemplate = () => {
        return (
            <>
                <div className="my-2">
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                    <Button icon="pi pi-refresh" className="p-button-rounded p-button-info mr-2" onClick={() => { props.setReload(!props.reload); setFilters(EmptyAssignmentFilter) }} />

                </div>
            </>
        );
    };
    const openNew = () => {
        props.setModal({ open: true, singleData: emptyAssignment });
    };
    const action = (rowData: IAssignment) => {
        return (
            <div className="flex gap-1">
                {rowData.login_Id === loginObj?.id && (<Button className="pi pi-pencil text-primary bg-white border-none" onClick={() => openEdit(rowData)}></Button>)}
                {rowData.reject_Reason ? (<Button className="pi pi-eye" style={{ color: "black", background: "red" }} onMouseEnter={(e) => showReasonOverlay(e, rowData)}></Button>) : null}
            </div>
        );
    };

    const showReasonOverlay = (event: React.MouseEvent<HTMLSpanElement, MouseEvent>, rowData: any) => {
        setRejectedReason(rowData);
        if (rejectOverlayPanelRef.current) {
            rejectOverlayPanelRef.current.toggle(event); // Show the OverlayPanel
        }
    }

    const openEdit = async (rowData: IAssignment) => {
        const response = await Fetch('Assignment_Mast/getAssignment', 'GET', null, `Id=${rowData.id}`, props.toast);
        if (response) {
            const data = await response.json();
            props.setModal({ open: true, singleData: { ...rowData, assignment: data } });
        }
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Assignments</h5>
        </div>
    );

    const loadTableData = async () => {
        const response = await Fetch('Assignment_Mast/assignment', 'GET', null, `lazyParams=${JSON.stringify(lazyParams)}&filter=${JSON.stringify(filters)}`, props.toast);
        if (response) {
            const data = await response.json();
            // console.log(data.totalRecords);
            setTableData(data.assignmentData);
            setTotalRecords(data.totalRecords);

        }
    };

    const AssignmentApproved = (rowData: IAssignment) => {
        return (
            <span style={{ color: rowData.is_Approved === true ? 'green' : 'red' }} className="cursor-pointer" onClick={() => { toggleVal(rowData); }} >
                {rowData.is_Approved ? "Approved" : "Pending"}
            </span>
        );
    };
    const toggleVal = async (rowData: IAssignment) => {
        if (rowData.is_Approved === true) {
            props.toast.current.show({ severity: 'error', detail: 'Status Can not be changed once approved', life: 3000 });
            return;
        }
        const response = await Fetch("Assignment_Mast/approveAssignment", "PUT", null, `Id=${rowData.id}`, props.toast);
        if (response) {
            let message: string = "Status Changed";
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            loadTableData();
        }
    };
    ;

    const fomatStartDate = (rowData: IAssignment) => {
        let date;
        if (rowData.start_Date) date = format(new Date(rowData.start_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return <>{date}</>;
    };

    const formatEndDate = (rowData: IAssignment) => {
        let date;
        if (rowData.end_Date) date = format(new Date(rowData.end_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return <>{date}</>;
    };

    const AchievedTemplated = (rowData: any) => {
        const maxPerRow = 3;
        const rows = [];
        const achievedDetails = rowData?.achieved_Detail || [];

        for (let i = 0; i < achievedDetails.length; i += maxPerRow) {
            rows.push(achievedDetails.slice(i, i + maxPerRow));
        }

        return (
            <div>
                {rows.map((row, rowIndex) => (
                    <div key={rowIndex} className="flex gap-1 justify-start" style={{ marginBottom: "5px" }}>
                        {row.map((item: any, index: number) => (
                            <div key={index} className="m-2 p-3 shadow-2 border-2 border-primary-100" style={{ cursor: rowData.login_Id === loginObj?.id ? 'pointer' : 'not-allowed', opacity: rowData.login_Id === loginObj?.id ? 1 : 0.6 }}

                                onClick={() => {
                                    if(rowData.login_Id !== loginObj.id) return;
                                    if (!rowData.is_Approved) {
                                        props.toast.current.show({ severity: 'error', detail: 'Your Assignment has not been approved yet. Please contact your sales head', life: 3000 });
                                        return;
                                    }
                                    setSelectedDate(item.date);
                                    setSelectedRowData(rowData);
                                    setDialogInputValue(0);
                                    setDialogVisible((!(_roles.includes(4) || _roles.includes(5)) && rowData.is_Approved === true && rowData.verify_Achieved === null) ? true : false);
                                }}
                            >

                                {`${new Date(item?.date).toLocaleDateString('en-GB').slice(0, 2)}`}/{item.achievedValue}
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        );
    };


    const renderDialogContent = () => {
        if (!selectedDate || !selectedRowData) return null;

        const saveAchieved = async () => {
            if (!dialogInputValue) {
                props.toast.current.show({ severity: 'error', detail: 'Input cannot be empty.', life: 3000 });
                return;
            }
            setLoading(true);
            const payload = {
                achieved: dialogInputValue,
                assigned_Assignment_Id: selectedRowData.id,
                achievement_Date: selectedDate,
            };
            const response = await Fetch('Assignment_Mast/postAchieved', 'POST', payload, null, props.toast);
            if (response) {
                const message = 'Achievement saved successfully!';
                props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
                setDialogVisible(false);
                loadTableData();
            }
            setLoading(false);
        };

        return (
            <div className="flex gap-2">
                <InputText style={{ width: '9vw' }} value={dialogInputValue} disabled={selectedRowData.is_Approved ? false : true} onChange={(e: any) => setDialogInputValue(e.target.value)} />
                <Button label="Save" loading={loading} className="text-primary bg-white" onClick={saveAchieved}></Button>
            </div>
        );
    };

    const AchievedApproved = (rowData: any) => {
        const statusText = rowData.verify_Achieved === null ? "Not Verified" : rowData.verify_Achieved ? "Verified" : "Rejected";
        const statusColor = rowData.verify_Achieved === null ? "orange" : rowData.verify_Achieved ? "green" : "red";
        const handleClick = () => {
            if (rowData.verify_Achieved === true || rowData.verify_Achieved === false) {
                props.toast.current.show({ severity: 'error', detail: "Status Can not be changed once Verified or Reject", life: 3000 });
                return;
            } else if (rowData.is_Approved === false) {
                props.toast.current.show({ severity: 'error', detail: "First Approve the Assignment", life: 3000 });
            }
            else {
                openVerifyDialog(rowData.id);
            }
        };
        return (
            <span style={{ color: statusColor }} className="cursor-pointer" onClick={handleClick} >{statusText}</span>
        );
    };

    const openVerifyDialog = (assignment_Id: number) => {
        setSelectedRow(assignment_Id);
        setVerifyStatus(null);
        setRejectionReason('');
        setVerifyDialogVisible(true);
    };

    const saveVerify = async () => {
        const payload = {
            id: selectedRow,
            status: verifyStatus,
            reason: verifyStatus === false ? rejectionReason : null,
        };
        const response = await Fetch('Assignment_Mast/VerifyAchieved', "POST", payload, null, props.toast);
        if (response) {
            const message = verifyStatus === true ? "Assignment Approved" : "Assignment Rejected";
            props.toast?.current?.show({ severity: 'success', detail: message, life: 3000 });
            setVerifyDialogVisible(false);
        }
        loadTableData();
    }

    const verifyDialog = (
        <Dialog visible={verifyDialogVisible} style={{ width: '50vw' }} header="Verify Assignment" className='p-fluid' onHide={() => setVerifyDialogVisible(false)} >
            <div className="field">
                <Dropdown id="verifyStatus" value={verifyStatus} options={verifyOptions} onChange={(e) => setVerifyStatus(e.value)} placeholder="--Select Status--" />
            </div>
            {verifyStatus === false && (
                <div className="field">
                    <label htmlFor="rejectionReason">Rejection Reason</label>
                    <InputTextarea id="rejectionReason" value={rejectionReason} onChange={(e) => setRejectionReason(e.target.value)} rows={3} placeholder="Provide a reason for rejection" />
                </div>
            )}
            <div className="flex justify-content-end mt-3">
                <Button label="Save" onClick={saveVerify} disabled={verifyStatus === false && rejectionReason === ""} />
            </div>
        </Dialog>
    )

    const actionBodyTemplate = (rowData: any) => {
        return (
            <span className="p-button p-button-text" onMouseEnter={(e) => showOverlay(e, rowData)}>
                {rowData.assignment_Name}
            </span>
        );
    };

    const showOverlay = (event: React.MouseEvent<HTMLSpanElement, MouseEvent>, rowData: any) => {
        setSelectedData(rowData);
        if (overlayPanelRef.current) {
            overlayPanelRef.current.toggle(event); // Show the OverlayPanel
        }
    };

    const TargetProgress = (rowData: any) => {
        const targetValue = rowData?.target || 0;
        const achievedValue = rowData?.totalAchieved || 0;
        const progress = Math.min((achievedValue / targetValue) * 100, 100);
        let progressColor = 'red';
        if (progress >= 50 && progress < 100) {
            progressColor = 'orange';
        } else if (progress === 100) {
            progressColor = 'green';
        }
        return (
            <div>
                <ProgressBar value={progress.toFixed(0)} style={{ width: "120px" }} color={progressColor} />
                <div className="text-sm mt-1 text-center">
                    <span>{`${achievedValue}`}/{`${targetValue}`}</span>
                </div>
            </div>
        );
    };

    const ratingTemplate = (rowData: IAssignment) => {
        // console.log(rowData);
        return (
            <>
                {(rowData.is_Approved === true && rowData.verify_Achieved === true) &&
                    <>
                        <Rating value={rowData.rating} onChange={(e: any) => onSetRating(e.value, rowData)} cancel={false} />
                        {(_roles.includes(4) || _roles.includes(5)) && <Button type='button' onClick={postRating} className='pi pi-check ml-2' ></Button>}
                    </>
                }
            </>
        )
    }

    const onSetRating = (rating: number, rowData: IAssignment) => {
        const ratingPoint = tableData.map((item) =>
            item.id === rowData.id ? { ...item, rating: rating } : item
        );
        setTableData(ratingPoint);
    }

    const postRating = async () => {
        const ratingData = tableData.filter(item => item.rating).map(item => ({ assignment_User_Id: item.id, rating: item.rating }));
        var payLoad = {
            assignment_User_Id: ratingData[0].assignment_User_Id,
            rating: ratingData[0].rating
        }
        const response = await Fetch('Assignment_Mast/postRating', 'POST', payLoad, null, props.toast);
        if (response) {
            props.toast?.current?.show({ severity: 'success', detail: 'Ratings submitted successfully!', life: 3000 });
            loadRatingSummary();
        }
    };

    var veryPoor = rating.find(f => f.rating === 1);
    var poor = rating.find(f => f.rating === 2);
    var Average = rating.find(f => f.rating === 3);
    var good = rating.find(f => f.rating === 4);
    var excellent = rating.find(f => f.rating === 5);

    const RatingSummary = (
        <Card>
            <div className="flex justify-content-between align-items-center p-3">
                <div className="flex gap-2 align-items-center">
                    <div className="w-2rem h-2rem" style={{ background: "red" }}></div>
                    <span className='text-xl font-bold cursor-pointer' onClick={() => handleRatingFilter(1)} >Very Poor:</span> <span className="mt-0 text-xl" style={{ color: "red" }}>{veryPoor?.count ? veryPoor?.count : 0}</span>
                </div>
                <div className="flex  gap-2 align-items-center">
                    <div className="w-2rem h-2rem bg-orange-500"></div>
                    <span className='text-xl font-bold cursor-pointer' onClick={() => handleRatingFilter(2)} >Poor:</span><span className="mt-0 text-xl text-orange-500">{poor?.count ? poor?.count : 0}</span>
                </div>
                <div className="flex gap-2 align-items-center">
                    <div className="w-2rem h-2rem bg-yellow-500 "></div>
                    <span className='text-xl font-bold cursor-pointer ' onClick={() => handleRatingFilter(3)}>Average:</span> <span className="mt-0 text-xl text-yellow-500">{Average?.count ? Average?.count : 0}</span>
                </div>
                <div className="flex gap-2 align-items-center">
                    <div className="w-2rem h-2rem bg-blue-500"></div>
                    <span className='text-xl font-bold cursor-pointer' onClick={() => handleRatingFilter(4)}>Good:</span><span className="mt-0 text-xl" style={{ color: "skyblue" }}>{good?.count ? good?.count : 0}</span>
                </div>
                <div className="flex gap-2 align-items-center">
                    <div className="w-2rem h-2rem bg-green-500"></div>
                    <span className='text-xl font-bold cursor-pointer' onClick={() => handleRatingFilter(5)}>Excellent:</span><span className="mt-0 text-xl" style={{ color: "green" }}>{excellent?.count ? excellent?.count : 0}</span>
                </div>
            </div>
        </Card>
    );

    const handleRatingFilter = (ratingValue: number) => {
        const updatedFilters = { ...filters, rating: ratingValue };
        setFilters(updatedFilters);
    };

    const loadRatingSummary = async () => {
        const response = await Fetch("Assignment_Mast/ratingSummary", "GET", null, null, props.toast);
        if (response) {
            const data = await response.json();
            setRating(data);
        }
    }

    useEffect(() => {
        loadTableData();
        loadRatingSummary()
    }, [props.reload, filters, lazyParams]);

    const DateFormat = loginObj?.date_Format;

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate}></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter filters={filters} setFilters={(filters: IAssignmentFilter) => setFilters(filters)} loading={loading} />
                </AccordionTab>
            </Accordion>
            {RatingSummary}
            <DataTable
                style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small"
                stripedRows
                scrollable
                scrollHeight="75vh"
                value={tableData}
                lazy key="id"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={totalRecords} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                showGridlines
                emptyMessage="No Requirements found."
                header={header}
                autoLayout
                columnResizeMode="fit"
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1} style={{ maxWidth: "50px" }} />
                <Column field="assigned_Name" header="User Name" style={{ maxWidth: "250px" }} />
                <Column field='assignment_Name' header="Assignment Name" body={actionBodyTemplate} style={{ maxWidth: "250px" }} />
                {/* <Column field="start_Date" header="Start Date" body={fomatStartDate} style={{ maxWidth: "120px" }} /> */}
                <Column field="start_Date" header="Start Date" body={(rowData : any) => safeFormatDate (rowData.start_Date, "dd/MM/yyyy", DateFormat)} style={{ maxWidth: "120px" }} />
                {/* <Column field="end_Date" header="End Date" body={formatEndDate} style={{ maxWidth: "120px" }} /> */}
                <Column field="end_Date" header="End Date" body={(rowDate : any) => safeFormatDate(rowDate.end_Date, "dd/MM/yyyy", DateFormat)} style={{ maxWidth: "120px" }} />
                <Column field='' header="Target" body={TargetProgress} style={{ maxWidth: "150px" }} />
                <Column field='' header="Date/Achieved" body={(rowData: any) => AchievedTemplated(rowData)} />
                {((_roles.includes(4)) || (_roles.includes(5))) && <Column field="is_Approved" header="Assignment Approve" body={AssignmentApproved} style={{ maxWidth: "100px" }} />}
                {((_roles.includes(4)) || (_roles.includes(5))) && <Column field="" header="Achieved Verify" body={AchievedApproved} style={{ maxWidth: "100px" }} />}
                <Column field='' header="Rating" body={ratingTemplate} />
                {!((_roles.includes(4)) || (_roles.includes(5))) && <Column field="" header="Action" body={action} style={{ maxWidth: "100px" }} />}
            </DataTable>
            <OverlayPanel ref={overlayPanelRef}>
                {selectedData && (
                    <div>
                        <p><strong>Description:</strong> {selectedData?.assignment_Descriptions}</p>
                    </div>
                )}
            </OverlayPanel>
            <OverlayPanel ref={rejectOverlayPanelRef}>
                {rejectedReason && (
                    <div>
                        <p><strong>Rejection Reason:</strong> {rejectedReason?.reject_Reason}</p>
                    </div>
                )}
            </OverlayPanel>
            <Dialog header={`Achieved ${new Date(selectedDate ? selectedDate : "").toLocaleDateString('en-GB')}`} visible={dialogVisible} style={{ width: '15vw' }} onHide={() => setDialogVisible(false)}>
                {renderDialogContent()}
            </Dialog>
            {verifyDialog}
        </>
    );
};